import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';
import { TUpdateWorkspacePaymentInfo } from '../types/workspace-payment-info';

export const getWorkspacePaymentInfo = (workspaceID: string) => {
    const query = {
        workspaceID,
    };
    const url = `${OCTOPUS_BASE_URL}/workspace-payment-info/`;
    const response = axios.get(url, { params: query });
    return response;
};

export const updateWorkspacePaymentInfo = (payload: TUpdateWorkspacePaymentInfo) => {
    const url = `${OCTOPUS_BASE_URL}/workspace-payment-info/`;
    const response = axios.put(url, payload);
    return response;
};
